import React from "react";
import Chip from "@material-ui/core/Chip";
import get from "lodash/get";
import {
  typeCommercialDocumentList,
  typeInvoiceAndCreditNoteList,
  typeTransactionList,
} from "pages/parents/conts";
import { find, isEmpty } from "lodash";
import { typeList } from "pages/busSchedules/util";
import {
  busScheduleStatusList,
  formTypeList,
  invoiceStatusList,
  statusList,
} from "pages/changeRequestForms/conts";
import { emailType } from "../pages/emailLogs/const";
import { useRecordContext } from "react-admin";
import { notificationTargetType } from "../pages/notifications/const";

interface ITypeField {
  label?: string;
  record?: any;
  source: string;
  type: string;
}

const getTypeList = (type: string) => {
  switch (type) {
    case "invoiceAndCreditNote":
      return typeInvoiceAndCreditNoteList;
    case "transaction":
      return typeTransactionList;
    case "busSchedule":
      return typeList;
    case "changeRequest_FormType":
      return formTypeList;
    case "changeRequest_busSchedule":
      return busScheduleStatusList;
    case "changeRequest_invoice":
      return invoiceStatusList;
    case "changeRequest_status":
      return statusList;
    case "commercialDocument":
      return typeCommercialDocumentList;
    case "emailSendingLog_Type":
      return emailType;
    case "notificationTarget_Type":
      return notificationTargetType;
    default:
      return;
  }
};

export const translateText = (text: string, type: string): string => {
  if (text) {
    const types = getTypeList(type);
    const findText = find(types, ["id", text]);

    return findText.name.toUpperCase();
  }
  // make capital to all type
};

const getColor = (text: string, type: string): string => {
  if (text) {
    const types = getTypeList(type);
    const findText = find(types, ["id", text]);

    return findText?.color;
  }
};

const TypeField = ({ label, record = {}, source, type }: ITypeField) => {
  const recordContext = useRecordContext();
  const records = isEmpty(record) ? recordContext : record;

  const text = get(records, source);
  const translated = translateText(text, type);
  const color = getColor(text, type);

  return (
    <div>
      <Chip
        label={translated}
        style={{ backgroundColor: `${color}`, color: "#FFF" }}
      />
    </div>
  );
};

export default TypeField;
